import { useSetAtom } from 'jotai';

import { Button, DrawerFooter } from '@growtherapy/sprout-ui';

import { ProviderDrawerState, drawerStateAtom } from '../state';

export function ClientInformationSchedulingDrawerFooter({
  onClickEditAppointment,
}: {
  onClickEditAppointment: () => void;
}) {
  return (
    <DrawerFooter>
      <Button use='secondary' onClick={onClickEditAppointment}>
        Edit appointment
      </Button>
    </DrawerFooter>
  );
}

export function ClientInformationSchedulingDrawerFooterWrapper() {
  const setDrawerState = useSetAtom(drawerStateAtom);
  return (
    <ClientInformationSchedulingDrawerFooter
      onClickEditAppointment={() => setDrawerState(ProviderDrawerState.EDIT_APPOINTMENT)}
    />
  );
}
